import React from 'react'

const EditIcon = (props) => {
  return (
    <svg 
      width="16" 
      height="16" 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={`edit-icon-hover ${props.className || ''}`}
      style={{ cursor: 'pointer', ...props.style }}
    >
      <path 
        d="M13.9378 5.35417L10.6253 2.0625L11.7295 0.958333C12.035 0.652778 12.4064 0.5 12.8437 0.5C13.2814 0.5 13.6462 0.652778 13.9378 0.958333L15.0212 2.0625C15.3267 2.35417 15.4831 2.71528 15.4903 3.14583C15.497 3.57639 15.3475 3.94444 15.042 4.25L13.9378 5.35417ZM12.8337 6.47917L4.04199 15.25H0.729492V11.9375L9.52116 3.16667L12.8337 6.47917Z"
        fill="#8E8E8E"
      />
    </svg>
  )
}

export default EditIcon
